<template>
    <div>
        <slglrs-base-header-sec title="Службени гласник РС Просветни гласник" slug="PG2010"></slglrs-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <form class="w-100" v-on:keyup.enter="search">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group form-group-sm pgpg">
                                <label class="form-label">Врста документа</label>
                                <!-- <select class="form-control" multiple="" size="4" v-model="docTypeIds">
                                    <option v-for="item in filters.docTypesLaws" :label="item.l" :value="item.k"
                                            v-bind:key="item.k">{{item.l}}
                                    </option>
                                </select>  -->
                                <multiselect v-model="docTypeIds" :options="filters.docTypesLaws" :multiple="true"
                                    placeholder="Сви" track-by="k" label="l" :show-labels="false"></multiselect>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group form-group-sm pgpg">
                                <label class="form-label">Доносилац</label>
                                <!-- <select id="br_god"
                                        multiple=""
                                        class="form-control full-width" size="4"
                                        v-model="authorityIds">
                                    <option v-for="item in filters.authorities" v-bind:key="item.k"
                                            :label="item.l" :value="item.k" selected="selected">{{item.l}}
                                    </option>
                                </select> -->
                                <multiselect v-model="authorityIds" :options="filters.authorities" :multiple="true"
                                    placeholder="Сви" track-by="k" label="l" :show-labels="false"></multiselect>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group form-group-sm">
                                <label for="number" class="form-label">Број гласила</label>
                                <input type="text" v-model="number" id="number" class="form-control full-width">
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label for="title_query" class="form-label">Речи садржане у наслову</label>
                        <div class="input-group ">
                            <input id="title_query" v-model="title_query" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" class="mr-2" id="title_query_all" v-model="title_query_all">
                                    <label class="in-btn-form-label" for="title_query_all">Све ове речи</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label for="text_query" class="form-label">Речи садржане у тексту</label>
                        <div class="input-group ">
                            <input id="text_query" v-model="text_query" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" class="mr-2" id="text_query_all" v-model="text_query_all">
                                    <label class="in-btn-form-label" for="text_query_all">Све ове речи</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="search_size" class="form-label mr-2">Величина резултата</label>
                                <select v-model="resultLimit" class="form-control">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search" v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-reset text-uppercase" @click="reset">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <result-counter v-if="searchResult !== null" :count="searchResult.resultSize"
                :limit="searchResult.limit"></result-counter>

            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields" responsive="sm">
                    <template v-slot:cell(name)="data">
                        <router-link target="_blank" :to="{ path: '/slglrs/viewAct/' + data.item.id }">
                            {{ data.item.name }}
                        </router-link>
                    </template>
                    <template v-slot:cell(timestamp)="data">
                        {{ data.item.date }}
                    </template>
                </b-table>

            </div>
        </div>
    </div>
</template>

<script>

import moment from 'moment';
import axios from 'axios';
import SlglrsBaseHeaderSec from '@/base_pages/slglrs/SlglrsBaseHeaderSec.vue';
import ResultCounter from '@/partials/ResultCounter.vue';

import { mapState } from 'vuex';

export default {
    name: "SlglrsPG2010_SearchPage",
    components: {
        SlglrsBaseHeaderSec,
        ResultCounter
    },
    data() {
        return {
            isActOpen: false,
            actHTML: '',
            result: [],
            resultSize: null,
            baseDIApiUrl: window.env.VUE_APP_API_DI_DEV,
            baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
            authorityType: null,
            docTypes: [],

            number: '',
            title_query: '',
            text_query: '',
            title_query_all: true,
            text_query_all: true,
            authorityIds: [],
            docTypeIds: [],
            yearFrom: null,
            yearTo: null,
            resultLimit: 50,

            filters: {
                docTypesLaws: [],
                docTypesAds: [],
                authorities: [],
            },
            searchResult: null,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
            fields: [
                { label: 'Назив', key: 'name', sortable: true },
                { label: 'Број', key: 'number', sortable: true },
                { label: 'Доносилац', key: 'authority', sortable: true },
                { label: 'Врста документа', key: 'docType', sortable: true },
                { label: 'Датум', key: 'timestamp', sortable: true }
            ],
        }
    },
    computed: {
        ...mapState(['userInfoState']),

        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('PG2010')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        openAct(actId) {
            axios.get(this.baseApiUrl + 'api/RegistarServlet/act-' + actId).then(response => {
                this.actHTML = response.data
            });
            this.isActOpen = true;
        },
        fetchData() {
            axios.get(this.baseSLGLApiUrl + 'Prins/PG2010/searchFilterInfo')
                .then(response => {
                    this.filters = response.data;
                    this.reset();
                });
        },
        search() {
            let dids = [];
            this.docTypeIds.filter(obj => {
                dids.push(obj.k);
            });

            let aids = [];
            this.authorityIds.filter(obj => {
                aids.push(obj.k);
            });
            var url = this.baseDIApiUrl + 'PG2010/search';
            const vm = this;
            var data = {
                bk: this.text_query === '' ? null : this.text_query,
                tk: this.title_query === '' ? null : this.title_query,
                bmo: this.text_query_all,
                tmo: this.title_query_all,
                limit: this.resultLimit,
                yf: this.yearFrom,
                yt: this.yearTo,
                n: this.number === '' ? null : this.number,
                aids: aids,
                dids: dids,
                il: true,
                //     il: this.documentType === 'laws',
            };

            axios.post(url, data).then(response => {
                this.searchResult = response.data;
                var data = response.data.result;
                for (var i = 0; i < data.length; i++) {
                    data[i].timestamp = moment(data[i].date, 'DD.MM.YYYY').valueOf();
                }
                this.result = data;
                this.resultSize = response.data.resultSize;

            }).catch(function (error) {
                if (error.response.status === 401) {
                    // nije ulogovan
                    // otvori modal za logovanje
                    vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                }
                console.log(error);
            });

        },
        reset() {
            this.number = '';
            this.docTypeIds = [];
            this.authorityIds = [];

            if (this.$route.query.q) {
                this.title_query = this.$route.query.q;
            } else {
                this.title_query = '';
            }
            this.text_query = '';
            this.title_query_all = true;
            this.text_query_all = true;

            this.resultLimit = 50;

            this.result = [];
            this.resultSize = null;
            this.searchResult = null;
        }
    },
    watch: {
        // documentType: function () {
        //     this.docTypeIds = [];
        //     if (this.documentType === 'laws') {
        //         this.docTypes = this.filters.docTypesLaws;
        //     } else this.docTypes = this.filters.docTypesAds;
        // },
        // resultLimit: function () {
        //     this.resultSize = null;
        // }
    },
    created() {
        this.fetchData();
    },
    mounted() {
        if (this.$route.query.q) {
            this.title_query = this.$route.query.q;
            this.search();
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_slglrs';
    }
}
</script>

<style>
.table-bootstrap-vue thead tr th:first-child {
    width: 50%;
}

.pgpg .multiselect__tag {
    background: #409edc !important;
    margin-top: 4px;
}

.pgpg .multiselect__placeholder {
    color: black !important;
    font-size: 0.9rem;
}

.pgpg .multiselect__select:before {
    border-color: black transparent transparent !important;
    border-width: 6px 3px 0 !important;
    opacity: 0.8;
}

.pgpg .multiselect__tags {
    border-radius: unset !important;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.22);
    padding: 4px 40px 0 12px !important;
    border: 1px solid #ced4da;

}

.multiselect {
    min-height: 35px;
}

.multiselect__select {
    top: 4px !important;
    right: -9px !important;
}

#__BVID__116 {
    margin-top: -2px;
}

.pgpg .multiselect__option--highlight {
    background: #409edc !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>